<div class="common-container">
  <p class="common-info">Upload initial source documents and collections for your workspace.</p>
  @if (currentSourceDocIsLoading$ | async) {
    <mat-progress-spinner [diameter]="40" mode="indeterminate"></mat-progress-spinner>
  }
</div>

@if (selectedStatusDoc$ | async; as data) {
  <ng-container>
    <div class="document-content">
      <h3 class="section-title">
        Standalone Files ({{ data?.files?.length ?? 0 }})
        <button mat-icon-button (click)="refetchDocs()" class="refresh-button" matTooltip="Manual Refresh">
          <mat-icon>refresh</mat-icon>
        </button>
        <button
          [disabled]="isDisabledEdit$ | async"
          *appRequiredRoles="[{ role: 'admin', status: ['DRAFTING'] }]"
          mat-icon-button
          [matMenuTriggerFor]="sourceMenu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #sourceMenu="matMenu">
          <button (click)="openUploadDialog()" mat-menu-item>
            <mat-icon>assignment_add</mat-icon>
            <span>Upload source document</span>
          </button>
        </mat-menu>
      </h3>
      <mat-tab-group (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="All"></mat-tab>
        <mat-tab [label]="'Waiting (' + statusNumberOfDoc.wait + ')'"></mat-tab>
        <mat-tab [label]="'Processing (' + statusNumberOfDoc.processing + ')'"></mat-tab>
        <mat-tab [label]="'Processed (' + statusNumberOfDoc.processed + ')'"></mat-tab>
        <mat-tab class="last-status" [label]="'Failed (' + statusNumberOfDoc.failed + ')'"></mat-tab>
      </mat-tab-group>
      @if (data && data.files.length > 0) {
        <mat-list class="file-list">
          @for (file of data.files; track file.file_id) {
            <mat-list-item class="standalone-file">
              <mat-icon class="file-icon" matListItemIcon color="primary">insert_drive_file</mat-icon>
              <div class="standalone-file-extra">
                <div class="standalone-file-meta">
                  <span matListItemTitle
                    >{{ file.file_name }}
                    @if (file.status) {
                      <span class="doc-status" [class]="file.status | documentStatusColor"
                        >({{ file.status | documentStatus }})</span
                      >
                    }
                  </span>
                  <span matListItemLine class="file-meta">
                    Uploaded on {{ file.uploaded_at | date: 'short' }} (ID: {{ file.file_id }})
                  </span>
                </div>
                <button
                  *appRequiredRoles="[{ role: 'admin', status: ['DRAFTING'] }]"
                  [disabled]="currentFilesBeingDeleted[file.file_id] || (isDisabledEdit$ | async)"
                  (click)="deleteStandaloneFile(file)"
                  class="standalone-file-delete"
                  #tooltip="matTooltip"
                  matTooltip="Delete file from source docs."
                  mat-icon-button>
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-list-item>
            @if (!$last) {
              <mat-divider></mat-divider>
            }
          }
        </mat-list>
      } @else {
        <p class="text-muted">No standalone documents found.</p>
      }

      <h3 class="section-title">
        Associated Collections ({{ data?.collections?.length ?? 0 }})
        <button
          [disabled]="isDisabledEdit$ | async"
          *appRequiredRoles="[{ role: 'admin', status: ['DRAFTING'] }]"
          mat-icon-button
          [matMenuTriggerFor]="collectionMenu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #collectionMenu="matMenu">
          <button (click)="openCopyDialog()" mat-menu-item>
            <mat-icon>library_books</mat-icon>
            <span>Copy collection</span>
          </button>
        </mat-menu>
      </h3>
      @if (data && data.collections.length > 0) {
        <mat-accordion multi>
          @for (collection of data.collections; track collection.id) {
            <mat-expansion-panel class="collection-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="panel-icon">folder</mat-icon>
                  {{ collection.name }} ({{ collection.files.length }} files)
                </mat-panel-title>
              </mat-expansion-panel-header>
              <button
                *appRequiredRoles="['admin', 'editor']"
                [disabled]="currentCollectionsBeingDeleted[collection.id] || (isDisabledEdit$ | async)"
                (click)="deleteCollection(collection)"
                class="delete-collection"
                mat-flat-button>
                <div>
                  @if (currentCollectionsBeingDeleted[collection.id]) {
                    <mat-icon>hourglass_empty</mat-icon>
                  } @else {
                    <mat-icon>delete</mat-icon>
                  }
                  Delete collection
                </div>
              </button>
              @if (collection.files.length > 0) {
                <mat-list class="nested-file-list">
                  @for (file of collection.files; track file.file_id) {
                    <mat-list-item class="collection-file">
                      <mat-icon matListItemIcon>description</mat-icon>
                      <div matListItemTitle>{{ file.name }}</div>
                    </mat-list-item>
                    @if (!$last) {
                      <mat-divider></mat-divider>
                    }
                  }
                </mat-list>
              } @else {
                <p class="text-muted p-3">This collection is empty.</p>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      } @else {
        <p class="text-muted">No collections associated with this workspace.</p>
      }
    </div>
  </ng-container>
}
@if (currentSourceDocIsError$ | async) {
  <app-common-error-loading></app-common-error-loading>
}
